import { Tooltip, withStyles } from 'vopay';
import { useTranslation } from 'react-i18next';
import styleSheet from './LinkedAccountsBadge.module.scss';

const cn = withStyles(styleSheet);

interface LinkedAccountsBadgeProps {
  accounts: string[];
}

const LinkedAccountsBadge = ({ accounts }: LinkedAccountsBadgeProps) => {
  const { t } = useTranslation('translations', {
    keyPrefix: 'TransactionApproval.Configuration.Roles.LinkedAccountsBadge',
  });

  if (accounts.length === 0) return null;

  return (
    <Tooltip
      customElement={
        <span className={cn('badge')}>
          {t('badgeLabel', { count: accounts.length, defaultValue: '{{count}} Account(s)' })}
        </span>
      }
      hasButton={false}
      type="hover"
      position="bottom"
      information={
        <div className={cn('tooltipContent')}>
          <strong className={cn('tooltipTitle')}>
            {t('tooltipTitle', { count: accounts.length, defaultValue: '{{count}} Account(s)' })}
          </strong>
          <ul className={cn('accountList', 'scrollbar')}>
            {accounts.map((account) => (
              <li key={account}>{account}</li>
            ))}
          </ul>
        </div>
      }
    />
  );
};

export default LinkedAccountsBadge;
